import React from 'react'
import ReactDOM from "react-dom";
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Modal, Button } from 'react-bootstrap'

import { closeAllModals } from './actions'
import { insertMacrosIntoObject } from '../template/actions'

// copy content from https://github.com/ae38/documentparsersdk/blob/master/ByteScout.DocumentParser/global_macros.json
// into `global_macros_clean.json 
// then replace inside from `"regex": .*` into `` (empty)

import macrosRawjsonData from './global_macros_reduced.json';
// use https://github.com/ae38/documentparsersdk/blob/master/ByteScout.DocumentParser/global_macros.json
// but just remove "regex" field for every item

// returns sorted macros
const macros = sortObject( JSON.parse(JSON.stringify(macrosRawjsonData)) );


class MacrosModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      filter: ""
    }
  }

  insertMacros = (macrosItem) => {
    this.props.insertMacrosIntoObject(this.props.activeObjectId, `{{${macrosItem}}}`)
    this.props.closeAllModals()
  }

  handleChangeFilter = (e) => {
    this.setState({
      filter: e.target.value
    })
  }

  handleClearFilter = () => {
    this.setState({
      filter: ""
    })
  }

  render() {
    const filter = this.state.filter.toLowerCase()
    var macrosList = []

    for (let [key, value] of Object.entries(macros)) {
      if (macros[key]["friendlyWriting"].toLowerCase().includes(filter) || macros[key]["description"].toLowerCase().includes(filter)) {
        macrosList.push(
          <tr
            className="macros-list-item"
            key={key}
            onClick={e => this.insertMacros(macros[key]["friendlyWriting"])}>
            <td>{macros[key]["friendlyWriting"]}</td>
            <td>{macros[key]["description"]}</td>
          </tr>
        )
      }
    }

    return (
      <Modal 
          
          // trying to fix issue with modal appearing behind some existing elements
          fade={false}
          style={{overlay: {zIndex: 999}, opacity: 1}}
          animation={false}      
          transition={false}
          // end of the fix     

        show={this.props.macrosModalOpened} 
        onHide={this.props.closeAllModals} 
        size="lg"
        >
        <Modal.Header closeButton>
          <Modal.Title>All Macros</Modal.Title>
          <div className="input-group mL-20 col-lg-8">    
            <input type="text" className="form-control" placeholder="type here to filter and search" value={this.state.filter} onChange={this.handleChangeFilter} />
            <div className="input-group-prepend">
              <button className="btn btn-outline-secondary" onClick={this.handleClearFilter}>clear</button>
            </div>

          </div>
        </Modal.Header>
        <Modal.Body>
          <div class="container">

            <h5 class="text-center alert-info">Find and click on a macro to insert into current expression field</h5>
            <br/>

            <table className="table table-striped">
              <tbody>
                {macrosList}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.props.closeAllModals}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    macrosModalOpened: state.modals.macrosModalOpened,
    template: state.template,
    activeObjectId: state.pdfViewer.activeObjectId
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    closeAllModals,
    insertMacrosIntoObject
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(MacrosModal)

// returns JSON sorted by keys A to Z
function sortObject(obj) {
  return Object.keys(obj).sort().reduce(function (result, key) {
      result[key] = obj[key];
      return result;
  }, {});
}

